import React from 'react';
import './IconSet.styles.scss';

const IconSet = ({ children }) => {
  return <div className="icon-set">{children}</div>;
};

export default IconSet;
